import PropTypes from 'prop-types';
import { Box, Button, Popover, Stack, TextField, Typography } from '@mui/material';

import Iconify from '../../../components/iconify';
import { RECORDING_COLORS } from './recordingColors';

RecordingChipPopover.propTypes = {
  anchorEl: PropTypes.any,
  recordingName: PropTypes.string,
  color: PropTypes.string,
  labelDraft: PropTypes.string,
  onLabelDraftChange: PropTypes.func.isRequired,
  onPickColor: PropTypes.func.isRequired,
  onCommitLabel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onRemoveRecording: PropTypes.func.isRequired,
};

/**
 * Recolour, relabel or remove one recording.
 *
 * Colour is saved the moment it is picked; the label is saved on Enter or when
 * the popover closes, so a half-typed label is not lost by clicking away.
 */
export default function RecordingChipPopover({
  anchorEl,
  recordingName,
  color,
  labelDraft = '',
  onLabelDraftChange,
  onPickColor,
  onCommitLabel,
  onClose,
  onRemoveRecording,
}) {
  return (
    <Popover
      open={anchorEl != null}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box sx={{ p: 1.5, minWidth: 220 }}>
        <Typography variant="caption" fontWeight="bold" sx={{ mb: 0.5, display: 'block' }}>
          {recordingName}
        </Typography>

        <Stack direction="row" spacing={0.5} sx={{ mb: 1 }}>
          {RECORDING_COLORS.map((c) => (
            <Box
              key={c.value}
              sx={{
                width: 24, height: 24, borderRadius: '50%', bgcolor: c.value, cursor: 'pointer',
                border: '2px solid',
                borderColor: color === c.value ? 'text.primary' : 'transparent',
                '&:hover': { transform: 'scale(1.2)' },
                transition: 'transform 0.1s',
              }}
              title={c.label}
              onClick={() => onPickColor(c.value)}
            />
          ))}
        </Stack>

        <TextField
          size="small"
          placeholder="Label (optional)"
          value={labelDraft}
          onChange={(e) => onLabelDraftChange(e.target.value)}
          fullWidth
          sx={{ mb: 1, '& .MuiInputBase-input': { fontSize: '0.8rem' } }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onCommitLabel();
          }}
        />

        <Button
          size="small"
          color="error"
          fullWidth
          startIcon={<Iconify icon="eva:trash-2-outline" />}
          onClick={onRemoveRecording}
        >
          Remove Recording
        </Button>
      </Box>
    </Popover>
  );
}
